// src/JobDetails.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { KeyUri } from "../key";

function JobDetails() {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${KeyUri.BACKEND_URI}/getJobPostById/${id}`)
      .then((response) => {
        setJob(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load job details");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div>Loading job details...</div>;
  if (error) return <div>{error}</div>;
  if (!job) return <div>Job not found.</div>;

  return (
    <>
    <div className="max-w-3xl p-6 mt-18 sm:mt-10 md:mt-28 sm:mb-4 md:mb-2 font-lato">
        <Link to="/careers" className="text-blue-600 hover:underline">
        ← Back to Careers
        </Link>
      </div>
    <div className="max-w-3xl mx-auto p-6 mt-18 sm:mt-2 md:mt-8 sm:mb-4 md:mb-2 bg-white shadow-md rounded-lg font-lato">

      <h1 className="text-3xl font-bold mb-4">{job.job_title}</h1>
      <p className="text-gray-700 mb-2">
        <strong>Description:</strong> {job.job_description}
      </p>
      <div className="mb-2">
        <strong>Location:</strong> {job.location}
      </div>
      <div className="mb-2">
        <strong>Department:</strong> {job.department}
      </div>
      <div className="mb-2">
        <strong>Employment Type:</strong> {job.employment_type}
      </div>
      <div className="mb-2">
        <strong>Salary:</strong> ₹{job.salary_range?.min} - ₹
        {job.salary_range?.max}
      </div>
      <div className="mb-2">
        <strong>Application Deadline:</strong>{" "}
        {new Date(job.application_deadline).toLocaleDateString()}
      </div>
      <div className="mb-4">
        <strong>Requirements:</strong>
        <ul className="list-disc list-inside ml-4">
          {job.requirements.map((req, index) => (
            <li key={index}>{req}</li>
          ))}
        </ul>
        <Link
  to={`/careers/apply/${job._id}`}
  className="inline-block mt-4 px-6 py-2 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700 transition"
>
  Apply Now
</Link>
      </div>
      
    </div>
    </>
  );
}

export default JobDetails;
